import {generateFetchOptions} from '../index';

export async function getApplicantCultureInformation(id: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/applicants/${id}/culture_type`,
    generateFetchOptions({
      method: 'GET',
      isProtected: true,
    })
  );
}
